import axios from 'axios';
import { getToken, removeToken} from './auth';
import { toast } from 'react-toastify';

axios.defaults.baseURL = process.env.REACT_APP_ENDPOINT
axios.defaults.timeout = 15000

const httpRequest = axios.create();
export const cancelTokenSource = axios.CancelToken.source()

httpRequest.interceptors.request.use(
  async (config: any) => {
    config.headers['Content-Type'] = 'application/json'
    config.headers['Authorization'] = 'Bearer ' + await getToken()
    return config;
  },
  (error) => {
    console.error('httpRequest: Error interceptor request:::', error.response)
    return Promise.reject(error);
  }
)

httpRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response) {
      if (
        error.response.status === 403 ||
        error.response.data.code === 'err_unauthorized'
      ) {
        removeToken();
        window.location.href = '/';
      }
      console.error(
        'httpRequest: Error interceptor response:::',
        error.response
      );
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || 'Failed performing action', {
          position: toast.POSITION.TOP_CENTER,
          pauseOnHover: false,
        });
        return Promise.reject(error.response.data);
      }
    } else {
      console.error(error);
    }
  }
)
export default httpRequest;